import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { PanelView } from "./PanelView";
import { AtletasView } from "./AtletasView";
import { DocumentosView } from "./DocumentosView";
import { CalidadView, MensajesView, ParticipacionesView } from "./ListViews";
import { RegistrosView, NuevoView } from "./RegistrosView";
import { RegistroForm } from "./RegistroForm";
import { AdminView } from "./AdminView";
import { CuentaView } from "./CuentaView";
import { FichaAtleta, FichaDocumento } from "./Fichas";
import { useApi } from "./useApi";
import { AsistenteView } from "./AsistenteView";
import { GaleriaView } from "./GaleriaView";
import { AliadosView } from "./AliadosView";

const TABS = [["panel", "Panel"], ["ia", "Asistente IA"], ["reg", "Registros"], ["nuevo", "Nuevo formulario"], ["atl", "Atletas"], ["part", "Participaciones"], ["cal", "Calidad de datos"], ["doc", "Documentos"], ["gal", "Galería"], ["msg", "Mensajes"]];

const download = async (params, name) => {
  try {
    const { data } = await api.get("/export", { params, responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = name;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (e) { toast.error(errMsg(e)); }
};

const Filters = ({ F, setF }) => {
  const { data } = useApi("/filtros");
  const p = { deporte: F.deporte, periodo: F.periodo };
  return (
    <div className="filters" data-testid="global-filters">
      <select value={F.deporte} onChange={(e) => setF({ ...F, deporte: e.target.value })} aria-label="Deporte" data-testid="filter-deporte-select">
        <option value="">Todos los deportes</option>
        {(data?.regDeportes || []).map((d) => <option key={d}>{d}</option>)}
      </select>
      <select value={F.periodo} onChange={(e) => setF({ ...F, periodo: e.target.value })} aria-label="Periodo" data-testid="filter-periodo-select">
        <option value="">Todos los periodos</option>
        {(data?.periodos || []).map((d) => <option key={d}>{d}</option>)}
      </select>
      <button className="btn xbtn" onClick={() => download({ ...p, formato: "json" }, "once-y-once-registros.json")} data-testid="export-json-btn">Exportar JSON</button>
      <button className="btn xbtn" onClick={() => download({ ...p, formato: "csv", coleccion: "registros" }, "once-y-once-registros.csv")} data-testid="export-csv-btn">Exportar CSV</button>
      <button className="btn xbtn" onClick={() => download({ formato: "csv", coleccion: "participaciones" }, "once-y-once-participaciones.csv")} data-testid="export-part-csv-btn">CSV participaciones</button>
    </div>
  );
};

export const TeamArea = () => {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("panel");
  const [F, setF] = useState({ deporte: "", periodo: "" });
  const [atleta, setAtleta] = useState(null);
  const [doc, setDoc] = useState(null);
  const [form, setForm] = useState(null);
  const [rev, setRev] = useState(0);
  const tabs = [...TABS, ...(user.role === "admin" ? [["ali", "Aliados"], ["admin", "Administración"]] : []), ["cuenta", "Mi cuenta"]];
  const openReg = (id) => setForm({ id });
  const newReg = (plantilla, prefill) => setForm({ plantilla, prefill });

  return (
    <div data-testid="team-area">
      <p className="note" data-testid="team-user-info">Sesión: <b>{user.name && user.name !== "Administrador" ? `${user.name} · ${user.email}` : user.email}</b> · {user.role === "admin" ? "Administrador" : "Psicólogo"}</p>
      <div className="tabs">
        {tabs.map(([k, l]) => (
          <button key={k} className="chip" aria-pressed={tab === k} onClick={() => setTab(k)} data-testid={`team-tab-${k}`}>{l}</button>
        ))}
        <button className="chip" onClick={logout} data-testid="team-logout-btn">Salir</button>
      </div>
      {["panel", "reg", "atl", "ia"].includes(tab) && <Filters F={F} setF={setF} />}
      <div key={rev}>
        {tab === "panel" && <PanelView F={F} onReg={openReg} onSeg={(p) => newReg("seguimiento", p)} />}
        {tab === "ia" && <AsistenteView F={F} />}
        {tab === "reg" && <RegistrosView F={F} onReg={openReg} />}
        {tab === "nuevo" && <NuevoView onNew={newReg} />}
        {tab === "atl" && <AtletasView onAtleta={setAtleta} globalDep={F.deporte} />}
        {tab === "part" && <ParticipacionesView />}
        {tab === "cal" && <CalidadView />}
        {tab === "doc" && <DocumentosView onDoc={setDoc} />}
        {tab === "msg" && <MensajesView />}
        {tab === "gal" && <GaleriaView />}
        {tab === "ali" && user.role === "admin" && <AliadosView />}
        {tab === "admin" && user.role === "admin" && <AdminView />}
        {tab === "cuenta" && <CuentaView />}
      </div>
      {atleta && <FichaAtleta id={atleta} onClose={() => setAtleta(null)} />}
      {doc && <FichaDocumento id={doc} onClose={() => setDoc(null)} />}
      {form && <RegistroForm {...form} defaults={F} onClose={() => setForm(null)} onSaved={() => { setForm(null); setRev((r) => r + 1); }} />}
    </div>
  );
};
